import React from 'react';
import '../css/Footer.css';
import Logo from './Logo';

const year = new Date().getFullYear();

export default () => {
  return (
    <footer>
      <div className='content'>
        <Logo></Logo>
        <p className='year'>&copy; {year}</p>
      </div>
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/main/Footer.js